
import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "@/events/index";

@Component
export default class Revive extends Vue {
  @Prop() protected id!: number;
  @Prop() protected display_name!: string;

  /**
   * Triggers the revive (restore) flow for a soft-deleted attribute.
   * The listener lives in the parent list component (Attribute.vue).
   */
  protected toggleRevive() {
    EventBus.$emit("reviveRow", this.id, this.display_name);
  }
}
